<script>
    import t from "../../localization/t.js";

    export let store;

    $: hasPrevious = $store.indexForCurrent > 0 && $store.all.length > 1;
    $: hasNext = $store.indexForCurrent < $store.all.length - 1;
    $: canOpenFullText = $store.indexForCurrent !== undefined;
    $: current = $store.all[$store.indexForCurrent];

    function didClickPreviousButton() {
        store.previous();
    }

    function didClickNextButton() {
        store.next();
    }
</script>

<button class:disabled={!hasPrevious} on:click={didClickPreviousButton}>
    <span>
        <svg width="11" height="13" viewBox="0 0 11 13" fill="none">
            <path d="M0 13V0L10.5 6.5L0 13Z" fill="black" />
        </svg>
    </span>
</button>

<button
    class="disabled"
    class:disabled={!hasNext}
    on:click={didClickNextButton}
>
    <svg width="11" height="13" viewBox="0 0 11 13" fill="none">
        <path d="M0 13V0L10.5 6.5L0 13Z" fill="black" />
    </svg>
</button>

<div class="spacer" />

{#if current && current.url}
    <a
        class:disabled={!canOpenFullText}
        href={current.url}
        target="_blank"
        rel="noreferrer"
    >
        {t("full_text")}
    </a>
{/if}

<style>
    button,
    a {
        appearance: none;
        cursor: pointer;
        margin: calc(var(--chrome-depth) * 3);
        border: none;
        background: none;
        padding: 0;
        touch-action: manipulation;
        color: black;
    }

    button:active,
    a:active {
        opacity: 0.5;
    }

    span {
        display: block;
        transform: scaleX(-1);
    }

    .spacer {
        flex-grow: 1;
    }

    .disabled {
        opacity: 0.25 !important;
        cursor: default;
    }

    a {
        position: relative;
        top: -1px;
    }
</style>
